import { SLIDER } from '../../../constants'

export const filterItemInitialProps = {
    className: 'product',
    imageClassName: "group-image",
    media: "(min-width: 1920px)",
    variants: SLIDER.PRODUCT
}